// extracted by mini-css-extract-plugin
export default {"box":"projectEntrance_box__bNvtK"};